<template>
    <div
        v-if="params.totalCount !== undefined && computedTotalCount > 0 && computedRowCount != computedTotalCount"
        class="py-2"
    >
        {{ $ti('grid.showingnumberoftotal', { rowCount: computedRowCount, totalCount: computedTotalCount }) }}
    </div>
    <div
        v-else
        class="py-2"
    >
        {{ $tm('grid.totalnumberofrows', computedRowCount) }}
    </div>
</template>
<script setup lang="ts">
import { $ti, $tm } from '@/locize';
import type { IStatusPanelParams } from 'ag-grid-community';
import { computed } from 'vue';

const props = defineProps<{
    params: IStatusPanelParams & { rowCount: () => number; totalCount?: () => number };
}>();

const computedRowCount = computed(() => {
    return props.params.rowCount();
});

const computedTotalCount = computed(() => {
    if (props.params.totalCount === undefined) {
        return 0;
    }
    return props.params.totalCount() ?? 0;
});
</script>
